import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-left">
          <span className="footer-brand">Bltz AI</span>
          <span className="footer-copy">&copy; {new Date().getFullYear()} Bltz AI, Inc. All rights reserved.</span>
        </div>
        <div className="footer-links">
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms" className="footer-link">Terms of Use</Link>
          <a href="mailto:support@bltz.ai" className="footer-link">Contact</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
